import { ColorPicker } from "./Colorpicker";
export default ColorPicker;
